module.exports = __webpack_public_path__ + "img/icon-alipay.66ca1707.png";